import React from 'react';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/common/Button';
import { useDemoFlowContext } from '@/components/pages/SituationalAwareness/context/DemoFlowContextProvider';
import { IncidentItem } from '@/server/services/GoogleBigQuery/BigQueryIncidentsClient.types';

export const PocProceedButton: React.FC<{ incident: Partial<IncidentItem> }> = ({ incident }) => {
  const t = useTranslations();
  const { isProceedEvent, isConfirmed, showConfirmationRoute, setProceedEvent } = useDemoFlowContext();

  const onClick = () => setProceedEvent(true);

  return (
    <Button
      label={t('proceed')}
      type="submit"
      size="md"
      width="fit-content"
      isLoading={isProceedEvent && !showConfirmationRoute && !isConfirmed}
      isActive={isProceedEvent}
      isDisabled={isProceedEvent}
      onClick={onClick}
    />
  );
};
